module.exports = __webpack_public_path__ + "img/image3.54e44c6b.jpeg";